class ProductMain extends HTMLElement {
  constructor() {
    super();
    this._selectors = {
      genderToggleWrapper: "[js-gender-toggle]",
      genderMen: "[js-gender-toggle-men]",
      genderWomen: "[js-gender-toggle-women]",
      colorSwatches: "[js-color-swatches-wrapper]"
    };
  }

  async connectedCallback() {
    const swatchesWrapper = this.querySelector(this._selectors.colorSwatches);
    const relatedProductGroup = this.getAttribute('data-style');
    const genderToggle = this.querySelector(this._selectors.genderToggleWrapper);
    if (swatchesWrapper != null || relatedProductGroup != null || relatedProductGroup != "" || genderToggle != null) {
      const relatedProductData = await this.getRelativeStyleProducts(relatedProductGroup);
      this._initRelatedColors(relatedProductData);
      this._initGenderToggleURL(relatedProductData);
    }
  }

  nostoCarouselLoad(){
    if (window.innerWidth > 768) return;
    const nostoCarousel = this.querySelector('.nosto-carousel');
    nostoCarousel.remove();
  }

  shopifySlug(tag) {
    return tag
      .toLowerCase()
      .replace(/[:.]/g, '-')         // remove colon and dot
      .replace(/\s+/g, '-')         // replace spaces with dash
      .replace(/[^a-z0-9-]/g, '')   // strip invalid chars
      .replace(/-+/g, '-');         // collapse multiple dashes
  }

  async getRelativeStyleProducts(styleTag) {
    const relatedStyleSlug = this.shopifySlug(styleTag);
    const targetURL = `/collections/all/${relatedStyleSlug}/?view=json`;
    return await this._getRelatedColorJSON(targetURL);
  }

  _initRelatedColors(relatedProductData) {
    this.relatedColorsContainer = this.querySelector(
      this._selectors.colorSwatches
    );

    if (this.relatedColorsContainer === null) {
      return;
    }

    const relatedColorsGroup =
      this.relatedColorsContainer.querySelector('.custom-color-selectors').getAttribute('data-group');
    const currentColorHandle =
      this.relatedColorsContainer.querySelector('.custom-color-selectors').getAttribute('data-currenthandle');  
    const targetURL = `/collections/all/${relatedColorsGroup}/?view=json`;
    const relatedColorsJSON = relatedProductData.filter(product => product.ygroup == relatedColorsGroup);
    let classicProducts = [];
    let limitedProducts = [];
    relatedColorsJSON.forEach(product => {
      if (product.limited_edition == "true") {
        limitedProducts.push(product);
      } else {
        classicProducts.push(product);
      }
    });

    //classic first, then limited
    let classicColorsMarkup = "";
    let finalClassic = "";
    if (classicProducts.length > 0) {
      classicProducts.forEach((product) => {
        let swatch = "";
          swatch = `<li class="${product.handle == currentColorHandle ? "current_active_color" : "" }"><a href="${product.handle == currentColorHandle ? "javascript:void(0)" : product.url }" class="color-id" dataid="${product.id}" data-pro-url="${ product.url }" data-color="${product.filter_color_family}"
            style="background:#D9D9D9;background-image: url('${product.featured_image}'); width: 60px; height: 60px"></a></li>`;

            classicColorsMarkup = `${classicColorsMarkup}${swatch}`;
      });
      finalClassic = `<div class="pdp-color" data-color-type="classic"><span>Classics</span><ul>${classicColorsMarkup}</ul></div>`;
    }

    let limitedColorsMarkup = "";
    let finalLimited = "";
    if (limitedProducts.length > 0) {
      limitedProducts.forEach((product) => {
        let swatch = "";
        swatch = `<li class="${product.handle == currentColorHandle ? "current_active_color" : "" }"><a href="${product.handle == currentColorHandle ? "javascript:void(0)" : product.url }" class="color-id" dataid="${product.id}" data-pro-url="${ product.url }" data-color="${product.filter_color_family}"
          style="background:#D9D9D9;background-image: url('${product.featured_image}'); width: 60px; height: 60px"></a></li>`;
  
          limitedColorsMarkup = `${limitedColorsMarkup}${swatch}`;
      });
      finalLimited = `<div class="pdp-color" data-color-type="limited"><span>Limited Edition</span><ul>${limitedColorsMarkup}</ul></div>`;
    }
    
    const finalColorSwatches = `${finalClassic}${finalLimited}`;
    
    this.relatedColorsContainer.querySelector(".custom-options.with-ygroup").innerHTML = finalColorSwatches;
  }

  _initGenderToggleURL(relatedProductData) {
    this.genderToggleContainer = this.querySelector(
      this._selectors.genderToggleWrapper
    );

    if (this.genderToggleContainer === null) {
      return;
    }

    const currentGender = this.genderToggleContainer.getAttribute('data-gender');
    const oppoGender = currentGender == "Men" ? "Women" : "Men" ;
    const currentHandle = this.genderToggleContainer.getAttribute('data-handle');
    const oppoGenderHandle = currentGender == "Men" ? currentHandle.replace('-mens', '-womens') : currentHandle.replace('-womens', '-mens') ;
    const currentToggle = currentGender == "Men" ? this.querySelector('[js-gender-toggle-men]') : this.querySelector('[js-gender-toggle-women]') ;
    const oppoToggle = currentGender == "Men" ? this.querySelector('[js-gender-toggle-women]') : this.querySelector('[js-gender-toggle-men]') ;

    const oppoRelatedProduct = relatedProductData.filter(product => product.filter_gender == oppoGender);

    if (oppoRelatedProduct.length > 0) {
      const oppoProduct = oppoRelatedProduct.find(product => product.handle == oppoGenderHandle);
      const defaultProduct = oppoRelatedProduct.find(product => product.gender_default == "true");
      if (oppoProduct) {
        oppoToggle.setAttribute('href', oppoProduct.url);
      } else if (defaultProduct) {
        oppoToggle.setAttribute('href', defaultProduct.url);
      } else {
        oppoToggle.setAttribute('href', oppoRelatedProduct[0].url);
      }
      this.genderToggleContainer.classList.remove('unabled');
    }
  }

  _getRelatedColorJSON(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
        return parsedJSON;
      })
  }
}

customElements.define("product-main", ProductMain);
